<template>
    <div class="requests">
        <div v-for="(request, idx) in requests" :key="idx">
            <pre>{{request}}</pre>
        </div>
    </div>
</template>

<script>

import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
    name: 'Debug',
    computed: {
    ...mapGetters(['requests'])
  },
}

</script>